import React, { useState } from "react";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("password");

  return (
    <div className="cust_container mt-4">
      <h3 className="mb-4">Account Settings</h3>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "password" ? "active" : ""}`}
            onClick={() => setActiveTab("password")}
          >
            Change Password
          </button>
        </li>
      </ul>

      <div className="card shadow-sm p-4">
        {/* {activeTab === "profile" && <EditProfile />} */}
        {activeTab === "password" && <ChangePassword />}
      </div>
    </div>
  );
};

export default SettingsPage;
